import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "Fire Safety Workshop",
        details: {
            date: "Thu, 01 Feb 2024",
            time: "10:00 AM - 4:00 PM",
            venue: "Community Center",
            organizer: "Fire Safety Council",
            number: "+123-456-7890",
            email: "info@firesafetyworkshop.com",
            entryFee: "Free Admission"
        },
        paragraphs: [
            "Join us for an informative Fire Safety Workshop and enhance your knowledge on fire prevention and emergency response strategies.",
            "Learn essential fire safety measures and emergency response techniques at our workshop. The Fire Safety Workshop aims to educate participants on proactive measures, risk assessment, and effective responses in case of a fire-related incident."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        agenda: [
            "Interactive Sessions on Fire Prevention Techniques.",
            "Demonstrations on Proper Use of Fire Extinguishers.",
            "Emergency Evacuation Drills and Procedures.",
            "Q&A Session with Fire Safety Experts.",
            "Networking Opportunities with Fire Safety Professionals."
        ],
        teamIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 2,
        image: images.event2,
        title: "Emergency Preparedness Drill",
        details: {
            date: "Wed, 14 Feb 2024",
            time: "9:00 AM - 12:00 PM",
            venue: "City Park",
            organizer: "Fire Safety Council",
            number: "+123-456-7890",
            email: "info@firesafetyworkshop.com",
            entryFee: "Free Admission"
        },
        paragraphs: [
            "Join us for an informative Fire Safety Workshop and enhance your knowledge on fire prevention and emergency response strategies.",
            "Learn essential fire safety measures and emergency response techniques at our workshop. The Fire Safety Workshop aims to educate participants on proactive measures, risk assessment, and effective responses in case of a fire-related incident."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        agenda: [
            "Interactive Sessions on Fire Prevention Techniques.",
            "Demonstrations on Proper Use of Fire Extinguishers.",
            "Emergency Evacuation Drills and Procedures.",
            "Q&A Session with Fire Safety Experts.",
            "Networking Opportunities with Fire Safety Professionals."
        ],
        teamIds: [3, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 3,
        image: images.event3,
        title: "Fire Safety Awareness Campaign",
        details: {
            date: "Thu, 29 Feb 2024",
            time: "2:00 PM - 5:00 PM",
            venue: "Local School",
            organizer: "Community Fire Department",
            number: "+123-456-7890",
            email: "awareness@firedept.org",
            entryFee: "Free Admission"
        },
        paragraphs: [
            "Help us spread fire safety knowledge among the youth with our Fire Safety Awareness Campaign. This event focuses on educating school children and staff about fire hazards and the importance of early prevention.",
            "Through engaging demonstrations and interactive sessions, our experts will share tips on identifying potential fire risks, using fire extinguishers, and reacting safely during emergencies."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        agenda: [
            "Interactive fire safety demonstrations for students.",
            "Presentation on common fire hazards in schools.",
            "Hands-on training with mini fire extinguishers.",
            "Distribution of educational fire safety materials.",
            "Quiz competition on fire safety with giveaways."
        ],
        teamIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 4,
        image: images.event4,
        title: "First Aid Training Session",
        details: {
            date: "Thu, 07 Mar 2024",
            time: "1:00 PM - 3:00 PM",
            venue: "Fire Department HQ",
            organizer: "Community Fire Department",
            number: "+123-456-7890",
            email: "training@firedept.org",
            entryFee: "Free Admission"
        },
        paragraphs: [
            "Join our First Aid Training Session to learn essential life-saving skills that can make a difference in emergencies. This session is perfect for community members, volunteers, and school staff.",
            "Certified instructors will guide attendees through CPR techniques, wound care, and emergency response strategies in a hands-on and easy-to-understand format."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        agenda: [
            "Introduction to basic first aid principles.",
            "Live CPR demonstrations and hands-on practice.",
            "Training on treating burns, cuts, and fractures.",
            "Q&A with certified first aid professionals.",
            "Distribution of quick-reference first aid guides."
        ],
        teamIds: [3, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 5,
        image: images.event5,
        title: "Fire Evacuation Drills",
        details: {
            date: "Sun, 17 Mar 2024",
            time: "3:00 PM - 6:00 PM",
            venue: "Residential Areas",
            organizer: "Community Fire Department",
            number: "+123-456-7890",
            email: "drills@firedept.org",
            entryFee: "Free Participation"
        },
        paragraphs: [
            "Experience a real-time Fire Evacuation Drill designed to enhance your response during fire emergencies. This drill will take place in selected residential neighborhoods to educate residents about safe evacuation procedures.",
            "Firefighters will guide participants through simulation scenarios and offer critical feedback to improve emergency readiness at home."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        agenda: [
            "Pre-drill safety briefing and instructions.",
            "Live fire evacuation simulation in residential zones.",
            "Demonstration of emergency exits and safety equipment.",
            "Resident feedback and discussion with fire officials.",
            "Distribution of home fire safety checklists."
        ],
        teamIds: [1, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    },
    {
        id: 6,
        image: images.event6,
        title: "Community Fire Safety Seminar",
        details: {
            date: "Mon, 25 Mar 2024",
            time: "6:00 PM - 8:00 PM",
            venue: "Community Hall",
            organizer: "Local Fire Safety Committee",
            number: "+123-456-7890",
            email: "seminar@firedept.org",
            entryFee: "Free Entry"
        },
        paragraphs: [
            "Join us for an informative Community Fire Safety Seminar aimed at raising awareness about fire prevention, home safety measures, and emergency preparedness. This session is open to all residents and includes a Q&A with fire safety experts.",
            "Learn practical tips to safeguard your home and family, understand common fire hazards, and receive valuable resources for creating your own fire safety plan."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        agenda: [
            "Welcome speech and seminar overview.",
            "Presentation on fire prevention and common hazards.",
            "Interactive Q&A session with fire experts.",
            "Distribution of educational materials and home safety kits.",
            "Networking and community discussion."
        ],
        teamIds: [3, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d95230.86755205364!2d-6.3874382!3d53.3330612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e9dc3c78e6f%3A0x4c7c0b28f310c8a0!2sDublin%2C%20Ireland!5e0!3m2!1sen!2s!4v1715801234567!5m2!1sen!2s"
    }


];

export default events;